import validate from "/home/runner/work/evaluation/evaluation/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.35_cac@6.7_12a9db74314e84023408f0ff055333ae/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/evaluation/evaluation/middleware/auth.global.ts";
import code_45global from "/home/runner/work/evaluation/evaluation/middleware/code.global.ts";
import https_45global from "/home/runner/work/evaluation/evaluation/middleware/https.global.ts";
import manifest_45route_45rule from "/home/runner/work/evaluation/evaluation/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.35_cac@6.7_12a9db74314e84023408f0ff055333ae/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  code_45global,
  https_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}